import React from 'react'

function DownTriangleIcon(props: any) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="7" viewBox="0 0 14 7" {...props}>
      <path
        fill="#263238"
        d="M7 0l7 7h-2.67L7 2.724 2.722 7H0z"
        data-name="Subtraction 345"
        transform="rotate(180 7 3.5)"
      ></path>
    </svg>
  )
}

export default DownTriangleIcon
